import { Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { DocsView } from './pages/DocsView';
import { LoginPage } from './pages/LoginPage';

type AuthState = 'loading' | 'authenticated' | 'unauthenticated';

const App: React.FC = () => {
  const [authState, setAuthState] = useState<AuthState>('loading');

  useEffect(() => {
    Auth.currentSession()
      .then(() => setAuthState('authenticated'))
      .catch(() => setAuthState('unauthenticated'));
  }, []);

  if (authState === 'loading') {
    return <></>;
  }

  if (authState === 'unauthenticated') {
    return <LoginPage onLogin={() => setAuthState('authenticated')} />;
  }

  return <DocsView onLogout={() => setAuthState('unauthenticated')} />;
};

export default App;
